import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface SeasonItem {
    season_id?:           number;
    name:                 string;
    points?:              string | null;
    punishment_version?:  number | null;
    start_date?:          string | null;
    planned_races?:       number | null;
    race_cadence_days?:   number | null;
    status?:              'planning' | 'active' | 'finished' | null;
    /** Max drivers per team in this season; 0 = unlimited. Enforced server-side. */
    max_team_size?:       number | null;
}

@Injectable()
export class SeasonsService {
    private apiUrl = `${environment.apiBaseUrl}/api/seasons.php`;

    constructor(private http: HttpClient) {}

    getSeasons(): Observable<SeasonItem[]> {
        return this.http.get<SeasonItem[]>(this.apiUrl);
    }

    /** The single active season (the "current season"); backend falls back to the latest. */
    getCurrentSeason(): Observable<SeasonItem> {
        return this.http.get<SeasonItem>(`${this.apiUrl}?current=1`);
    }

    createSeason(season: SeasonItem): Observable<SeasonItem> {
        return this.http.post<SeasonItem>(this.apiUrl, season);
    }

    updateSeason(season: SeasonItem): Observable<{ success: boolean }> {
        return this.http.put<{ success: boolean }>(this.apiUrl, season);
    }

    deleteSeason(season_id: number): Observable<{ success: boolean }> {
        return this.http.delete<{ success: boolean }>(this.apiUrl, { body: { season_id } });
    }
}
